import React, { useState } from "react";
import ConsentForm from "components/auth/ConsentForm";
import SignUpForm from "components/auth/SignUpForm";
import useUserDetailQuery from "features/user/hooks/queries/useUserDetailQuery";
import { Navigate } from "react-router-dom";
import { ROUTER_PATH } from "config/path";

const FORM_NAME = {
  consentForm: "consent-form",
  signUpForm: "sign-up-form",
} as const;

type FormName = (typeof FORM_NAME)[keyof typeof FORM_NAME];

const AuthSignUpPage = () => {
  const [currentForm, setCurrentForm] = useState<FormName>(
    FORM_NAME.consentForm,
  );

  const handleGoToForm = (form: FormName) => {
    setCurrentForm(form);
  };

  /* 로그인 시 리다이렉트 */
  const { data: currentUser } = useUserDetailQuery();

  if (!!currentUser) {
    return <Navigate to={ROUTER_PATH.home} replace />;
  }

  return (
    <>
      {currentForm === FORM_NAME.consentForm && (
        <ConsentForm onClickNext={() => handleGoToForm(FORM_NAME.signUpForm)} />
      )}
      {currentForm === FORM_NAME.signUpForm && <SignUpForm />}
    </>
  );
};

export default AuthSignUpPage;
